import { Folder, RepositoryIssue } from '@qality/common-model';
import { useMap } from '@qality/common-utils/src/hooks/useMap';

export type Key = 'all-test-cases' | Folder['id'];

export function useIssuesSelection() {
  const { setValue, getValue, getAllValues, hasKey, clear, clearAll, isEmpty } =
    useMap<Key, Array<RepositoryIssue>>();

  const selectIssues = (key: Key, value: Array<RepositoryIssue>): void => {
    if (value.length === 0) {
      return clear(key);
    }

    return setValue(key, value);
  };

  const getSelectedIssues = (key: Key): Array<RepositoryIssue> => {
    return getValue(key) ?? [];
  };

  const getAllSelectedIssues = (): Array<RepositoryIssue> => {
    return getAllValues().flat();
  };

  const hasSelectedIssues = (key: Key): boolean => {
    return hasKey(key);
  };

  const clearSelectedIssues = (key: Key): void => {
    clear(key);
  };

  const clearAllSelectedIssues = (): void => {
    clearAll();
  };

  const isAnyIssueSelected = (): boolean => {
    return !isEmpty();
  };

  const isKeyAllTestCases = (key: Key): key is 'all-test-cases' => {
    return key === 'all-test-cases';
  };

  const isFolderKey = (key: Key): key is Folder['id'] => {
    return key !== 'all-test-cases';
  };

  const getKey = (
    type: 'all-test-cases' | 'folder',
    key?: Folder['id']
  ): Key => {
    return type === 'all-test-cases' ? 'all-test-cases' : key;
  };

  return {
    selectIssues,

    getSelectedIssues,
    getAllSelectedIssues,

    hasSelectedIssues,

    clearSelectedIssues,
    clearAllSelectedIssues,

    isAnyIssueSelected,

    isKeyAllTestCases,
    isFolderKey,
    getKey,
  };
}
